import React, { FC } from 'react';
import styles from './Message.module.scss';

type Props = {
  content: string;
};

const Message: FC<Props> = ({ content }) => {
  return (
    <div>
      <h2 className={styles.center}>{content}</h2>
    </div>
  );
};

export default Message;
